import { VIOLATION_TYPE } from 'constants/restrictions'

export const getViolationId = (accept, alert) => {
  if (accept && !alert) return VIOLATION_TYPE.ACCEPT
  if (accept && alert) return VIOLATION_TYPE.ACCEPT_AND_ALERT
  if (!accept && alert) return VIOLATION_TYPE.REJECT_AND_ALERT

  return null
}
